import React from "react";

const FormInputGroup = ({
  text,
  icon,
  placeholder,
  value,
  onInput,
  onkeyup,
  readOnly = false,
}) => {
  return (
    <div className="input-group mb-3 flex-col">
      <span className="input-group-text w-100 " style={{fontSize:"15px"}}>
        {text}
        {icon}
      </span>
      <input
        type="number"
        className="form-control w-100"
        placeholder={placeholder}
        value={value}
        onInput={onInput}
        onKeyUp={onkeyup}
        readOnly={readOnly}
      />
    </div>
  );
};

export default FormInputGroup;
